/* unplugin-vue-components disabled */import { render } from "./popupAgreement.vue?vue&type=template&id=eac488a8&scoped=true"
import script from "./popupAgreement.vue?vue&type=script&lang=js"
export * from "./popupAgreement.vue?vue&type=script&lang=js"

import "./popupAgreement.vue?vue&type=style&index=0&id=eac488a8&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac488a8"]])

export default __exports__